import React, { useState } from "react";
import AddColor from "../components/AddColor";
import TableColor from "../components/TableColor";

const Colores = () => {
  const [show, setShow] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const refrescar = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-3">GESTION COLORES</h3>

      <AddColor show={show} setShow={setShow} onSaved={refrescar} />

      <TableColor refreshKey={refreshKey} />
    </div>
  );
};

export default Colores;